import React from 'react';

export function ProjectPersonnelDistribution() {
  const roles = [
    { label: 'Công nhân thi công', count: 18, percent: 50, color: 'bg-emerald-500' },
    { label: 'Kỹ thuật / Giám sát', count: 8, percent: 22, color: 'bg-blue-500' },
    { label: 'Quản lý dự án', count: 3, percent: 8, color: 'bg-sky-500' },
    { label: 'Tổ trưởng', count: 4, percent: 11, color: 'bg-indigo-500' },
    { label: 'Khác', count: 3, percent: 9, color: 'bg-slate-300' },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Phân bổ nhân sự</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>
      <div className="space-y-4">
        {roles.map((role, idx) => (
          <div key={idx} className="space-y-1.5">
            <div className="flex justify-between text-xs font-normal">
               <span className="text-slate-600">{role.label}</span>
               <span className="text-slate-900">{role.count} ({role.percent}%)</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-50 overflow-hidden">
               <div className={`${role.color} h-full transition-all duration-700`} style={{ width: `${role.percent}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
